import { Card, Col, Row } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { BreckpointSpecifics } from "../../../../Constant";
import { BREACKPOINT, BREACKPOINT_BODY, BREACKPOINT_HEAD } from "../../../../Data/BootstrapTable/BasicTable";
import CommonTable from "../Common/CommonTable";

export const BreckpointSpecific = () => {
  return (
    <Col sm="12">
      <Card>
        <CommonCardHeader title={BreckpointSpecifics} span={BREACKPOINT} table/>
        <Row className="card-block">
          <Col sm="12" lg="12" xl="12">
            <CommonTable tableClass="table-responsive-sm" headData={BREACKPOINT_HEAD}>
              {BREACKPOINT_BODY.map((data) => (
                <tr key={data.id}>
                  <th scope="row">{data.id}</th>
                  <td>{data.name}</td>
                  <td>{data.orderId}</td>
                  <td>{data.price}</td>
                  <td>{data.quantity}</td>
                  <td>{data.total}</td>
                </tr>
              ))}
            </CommonTable>
          </Col>
        </Row>
      </Card>
    </Col>
  );
};
